import React from 'react'
import { useTranslation } from 'react-i18next'

const HeaderAbout = () => {
  const { t } = useTranslation();
  return (
    <>
      <header className="py-5">
    <div className="container px-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-xxl-6">
          <div className="text-center my-5">
            <h1 className="fw-bolder mb-3">{t('about.mission')}</h1>
            <p className="lead fw-normal text-muted mb-4">
Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis iure cupiditate distinctio earum recusandae! Accusamus similique ipsum vel asperiores quo rem repellendus assumenda dolor velit, accusantium fuga eaque sint. Rem!            </p>
            {/* <a className="btn btn-primary btn-lg" href="#scroll-target">Lee nuestra historia</a> */}
          </div>
        </div>
      </div>
    </div>
  </header>

    </>
  )
}

export default HeaderAbout